export class Company {
  public id: string = "";
  public name: string = "";
  public active: boolean = true;
}
